export default __webpack_public_path__ + "static/media/mobile_81.ea3d156e.jpg";